import { FREEBIE_ITEM_IMAGE_SIZE, FREEBIE_ITEM_IMAGE_SIZE_V2 } from "./constants";

export const getFreebieImageSize = (isSnaccStorefrontV2 = false) => {
    const { WIDTH: width, HEIGHT: height } = isSnaccStorefrontV2 ? FREEBIE_ITEM_IMAGE_SIZE_V2 : FREEBIE_ITEM_IMAGE_SIZE;

    return { width, height };
};
